import React from 'react';

import { Button } from 'react-bootstrap5';

import { useContext } from '../Context';

export default function ContinueCpa() {
  const { dispatch, state, actions } = useContext();

  const onGoNextClick = () => {
    actions.setNextStep({
      dispatch,
      steps: state.steps,
      isPossibleSkip: true,
      currentStep: state.currentStep,
    });
  };

  return (
    <div className="content onboarding-content">
      <div className="row">
        <div className="col-lg order-lg-last">
          <div className="bg-photo bg-members-onboarding-welcome-photo" />
        </div>
        <div className="col-lg order-lg-first">
          <div className="pt-4 p-sm-4 pe-lg-0 h-100 d-flex flex-column">
            <h1>Welcome Back!</h1>
            <p className="mt-3">
              Please complete your Talent Assessment to get your personalized Report.
            </p>
            <div className="mt-auto">
              <Button
                className="d-block d-sm-inline-block"
                style={{ marginTop: '200px' }}
                onClick={onGoNextClick}
              >
                Let&apos;s Go!
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
